import { useSearchParams, Link } from 'react-router-dom';
import { AlertCircle } from 'lucide-react';
import styles from './BookingCancelled.module.css';

export default function BookingCancelled() {
  const [searchParams] = useSearchParams();
  const vennLink = searchParams.get('venn_link');

  return (
    <div className={styles.page}>
      <div className={styles.stateCard}>
        <div className={`${styles.stateIcon} ${styles.stateIconError}`}>
          <AlertCircle size={32} aria-hidden="true" />
        </div>
        <h1 className={styles.stateTitle}>Payment Cancelled</h1>
        <p className={styles.stateBody}>
          Your payment was not completed. No booking has been created.
        </p>
        {vennLink && (
          <Link to={`/venn/${vennLink}`} className={styles.retryLink}>
            Try Again
          </Link>
        )}
      </div>
      <div className={styles.footer}>
        <p>Powered by <span className={styles.footerBrand}>Vennio</span></p>
      </div>
    </div>
  );
}
